import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // order-reports

    fetchOrderList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/reports/order-list', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSingleOrder(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/reports/order-detail/${data.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // search reports
    fetchSearchRecords(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/reports/search-records', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSearchTermReport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/reports/search-terms', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // login reports
    fetchLoginRecords(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/reports/login-records', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLoginRecordDaily(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/reports/login-records-daily', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
